import Vue from 'vue'

export async function getLanguage() {
    const response = await Vue.prototype.$httpLocation.get('/language');
    return response
}